module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<% var i18n = require(\'../../locale\'); %>\n<h1 class="minecraft-big-yellow-header" id="getting-started-header"><%= i18n.minecraftNotConnected() %></h1>\n\n<h2 id="download-text"><%= i18n.connectToCodeConnection() %></h2>\n\n<div class="download-button" id="download-button"><%= i18n.downloadButton() %></div>\n\n<div id="close-popup"></div>\n', __filename = "src/craft/code-connection/dialogs/connectToCodeConnection.html.ejs";
    try {
        var __output = [], __append = __output.push.bind(__output);
        with (locals || {}) {
            var i18n = require("../../locale");
            __append('\n<h1 class="minecraft-big-yellow-header" id="getting-started-header">');
            __line = 2;
            __append(escapeFn(i18n.minecraftNotConnected()));
            __append('</h1>\n\n<h2 id="download-text">');
            __line = 4;
            __append(escapeFn(i18n.connectToCodeConnection()));
            __append('</h2>\n\n<div class="download-button" id="download-button">');
            __line = 6;
            __append(escapeFn(i18n.downloadButton()));
            __append('</div>\n\n<div id="close-popup"></div>\n');
            __line = 9;
        }
        return __output.join("");
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}